export default "__VITE_ASSET__DmWiuSAx__"